import { ActionMenu } from 'components/ActionStyles/ActionStyles'
import LockIcon from 'components/icons/LockIcon'
import RightArrow from 'components/icons/RightArrow'
import {
  CandCount,
  CardSectionFlex,
  CardText,
  CardsDiv,
  CardsFlex,
  CardsRowFlex,
  CardsValue,
  RoleFlex,
  RoleNumber,
  RoleTitle,
} from 'modules/Drives/ViewDriveRole/Style/style'
import React from 'react'
import { COLORS } from 'theme'
import { getZeroBeforeInt } from 'utils/getZeroBeforeInt'

export const roleMenu = (onRoleChange, roleMenu = []) => (
  <ActionMenu
    width="335px"
    items={
      Array.isArray(roleMenu)
        ? roleMenu?.map((role, index) => {
            return {
              key: index,
              label: (
                <RoleFlex
                  row
                  spaceBetween
                  centerVertically
                  onClick={() => onRoleChange(role?.roleId)}
                >
                  <RoleFlex column>
                    <RoleNumber>Role {getZeroBeforeInt(index + 1)}</RoleNumber>
                    <RoleTitle>{role?.roleName}</RoleTitle>
                  </RoleFlex>
                  <CandCount>
                    {getZeroBeforeInt(role?.candidateCount)}
                  </CandCount>{' '}
                </RoleFlex>
              ),
            }
          })
        : Object.keys(roleMenu)
    }
  />
)

const DriveRoleMetrics = ({
  applicantMetrics,
  selectedRound,
  setSelectedRound,
  setSearchParams,
  setCurrentPage,
  setCurrentTab,
  setStatus,
  setFilterStatus,
  setLastRound,
  setCheckedIds,
  setCandidateFilterData,
}) => {
  const onClickRound = (round, lastRound, roundType) => {
    setCheckedIds([])
    setCandidateFilterData({
      rating: '',
      location: '',
      status: '',
      degreeDepartment: '',
      collegeName: '',
      gender: '',
      degreekeys: '',
    })
    setCurrentPage(0)
    setCurrentTab('SELECTED,REJECTED,HOLD,SCHEDULED,ABSENT,ACCEPTED')
    setStatus(round === 'offer' ? 'RELEASED' : 'ACTIVE')
    setFilterStatus('SELECTED,REJECTED,HOLD,SCHEDULED,ABSENT,ACCEPTED')
    setSelectedRound(round)
    setLastRound(lastRound)
    setSearchParams({ stage: round, type: roundType || null })
  }

  return (
    <div>
      <CardsRowFlex row wrap>
        <CardsDiv>
          <CardsFlex
            column
            onClick={() => onClickRound('applications')}
            isSelected={selectedRound === 'applications'}
            style={{
              pointerEvents: selectedRound === 'applications' ? 'none' : 'auto',
              width: '100%',
            }}
          >
            <CardText>Applications</CardText>
            <CardsValue>
              {getZeroBeforeInt(applicantMetrics?.candidateCount)}
            </CardsValue>
          </CardsFlex>
        </CardsDiv>

        {applicantMetrics?.round?.map((round, index, list) => {
          let allowRound = list.length === index && round.count !== 0
          if (list.length > index) {
            allowRound = !!list
              .slice(index, list.length)
              .find(ro => ro.count !== 0)
          }
          return (
            <CardSectionFlex key={index + 'roundList'} centerVertically>
              <CardsFlex
                column
                onClick={() =>
                  onClickRound(
                    round?.roundName,
                    list[index === 0 ? index : index - 1]?.roundName,
                    round?.type
                  )
                }
                isSelected={selectedRound === round?.roundName}
                style={{
                  pointerEvents:
                    selectedRound === round?.roundName || !allowRound
                      ? 'none'
                      : 'auto',
                  width: '100%',
                }}
              >
                <CardText>
                  {round?.roundName} &nbsp;{allowRound ? '' : <LockIcon />}
                </CardText>
                <CardsValue>{getZeroBeforeInt(round?.count)}</CardsValue>
              </CardsFlex>
              {applicantMetrics?.round?.length - 1 !== index && (
                <RightArrow color={COLORS.GREY_T_80} />
              )}
            </CardSectionFlex>
          )
        })}
      </CardsRowFlex>
    </div>
  )
}

export default DriveRoleMetrics
